"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icon = _interopRequireDefault(require("../icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = _interopRequireDefault(require("./index.scss"));

var BackLink = function BackLink(_ref) {
  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "children", "label"]);
  return _react["default"].createElement("a", (0, _extends2["default"])({}, restProps, {
    className: _index["default"].root
  }), _react["default"].createElement(_icon["default"], {
    size: "medium",
    className: (0, _classnames["default"])(_index["default"].icon, 'arrow-left'),
    type: "arrow-left"
  }), label);
};

BackLink.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  label: _propTypes.string,
  href: _propTypes.string
};
BackLink.defaultProps = {
  className: '',
  label: 'Back',
  href: 'javascript: history.back()'
};
var _default = BackLink;
exports["default"] = _default;